import * as React from "react";

import { cn } from "../../utils/cn";

export interface TextProps extends React.HTMLProps<HTMLParagraphElement> {}

const Text = React.forwardRef<HTMLParagraphElement, TextProps>(({ className, ...props }, ref) => {
  return <p className={cn("text-base md:text-md", className)} ref={ref} {...props} />;
});
Text.displayName = "Text";

export { Text };
